import { createContext } from 'react';

import { registerInfieldModeInMetrics } from '../../features/metrics/infield-mode';
import {
  type SelectedLocationContextValue,
  useCdmSelectedLocationContext,
} from '../selected-location-provider/cdm-selected-location-context';

export interface CdmAppConfigProviderContextInterface {
  useCdmSelectedLocationContext: () => Pick<
    SelectedLocationContextValue,
    'selectedLocationConfig' | 'allLocationConfigs'
  >;
  registerInfieldModeInMetrics: typeof registerInfieldModeInMetrics;
}

const defaultContextValue: CdmAppConfigProviderContextInterface = {
  useCdmSelectedLocationContext,
  registerInfieldModeInMetrics,
};

export const CdmAppConfigProviderContext =
  createContext<CdmAppConfigProviderContextInterface>(defaultContextValue);
